export default __webpack_public_path__ + "resources/icons/n312-b0b4.png";